import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { N500, N700 } from '@atlaskit/theme/colors';
import { ICON_STATES, PrimaryProductDisplayPropsType } from '../../model/index';
import { ProductIcon } from '../icon';
import { messagesByProductKey } from '../messages';
import { CharlieDisplayFontStack } from '../styled';

export function PrimaryProductDisplayView({
  productKey
}: PrimaryProductDisplayPropsType) {
  return (
    <PrimaryProductContainer>
      <ProductIcon
        productKey={productKey}
        iconState={ICON_STATES.PRIMARY_PRODUCT}
      />

      <PrimaryProductTextContentContainer>
        <PrimaryProductHeading>
          <FormattedMessage {...messagesByProductKey[productKey].name} />
        </PrimaryProductHeading>
        <PrimaryProductSubheading productKey={productKey}>
          <FormattedMessage {...messagesByProductKey[productKey].subHeading} />
        </PrimaryProductSubheading>
      </PrimaryProductTextContentContainer>
    </PrimaryProductContainer>
  );
}

export const PrimaryProductContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  align-items: center;

  @media (max-width: 778px) {
    margin-bottom: 36px;
  }

  @media (max-width: 510px) {
    margin-bottom: 16px;
    margin-top: -6px;
  }
`;

export const PrimaryProductTextContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const PrimaryProductHeading = styled.h2`
  font-family: ${CharlieDisplayFontStack};
  margin: 0;
  font-size: 32px;
  font-weight: 400;
  color: ${N700};
  letter-spacing: 0;
  line-height: 44px;

  @media (max-width: 1130px) {
    line-height: 34px;
  }

  @media (max-width: 1050px) {
    font-size: 26px;
  }

  @media (max-width: 510px) {
    font-size: 20px;
    line-height: 22px;
  }
`;

export const PrimaryProductSubheading = styled.h3<{ productKey: string }>`
  font-family: ${CharlieDisplayFontStack};
  font-weight: 300;
  margin: 0;
  font-size: 20px;
  color: ${N500};
  letter-spacing: 0px !important;
  line-height: 28px;

  @media (max-width: 1050px) {
    font-size: 18px;
    line-height: 22px;
    font-size: ${({ productKey }: { productKey: string }) =>
      productKey === 'jira-core.ondemand' ? '16px' : '18px'};
  }

  @media (max-width: 510px) {
    font-size: 12px;
    line-height: 20px;
  }
`;
